import { useaxios } from "../../../utils/useaxios";
export default (text) => recaller => setrecaller => items => setitems => settext => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('item/getitem.php', { text }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        }
        if (res == "request_failed") {
            alert('no internet connection');
            return false;
        }
        settext('');
        if (res.status == "ok") {
            if (items.find((lis) => lis.item_id == res.data[0].item_id)) {
                setitems(items.map((lis) => lis.item_id == res.data[0].item_id ? { item_id: lis.item_id, item_name: lis.item_name, item_barcode: lis.item_barcode, item_price: lis.item_price, item_base_price: lis.item_base_price, company_invoice_item_qty: Number(lis.company_invoice_item_qty) + 1, company_invoice_item_price: lis.company_invoice_item_price, company_invoice_item_cbi_m3: lis.company_invoice_item_cbi_m3, company_invoice_item_cbi_total_price: lis.company_invoice_item_cbi_total_price, item_unit_one_of_many: lis.item_unit_one_of_many } : lis));
            } else {
                setitems([{ item_id: res.data[0].item_id, item_name: res.data[0].item_name, item_barcode: res.data[0].item_barcode, item_price: res.data[0].item_price, item_base_price: 0, company_invoice_item_qty: 0, company_invoice_item_price: 0, company_invoice_item_cbi_m3: 0, company_invoice_item_cbi_total_price: 0, item_unit_one_of_many: res.data[0].item_unit_one_of_many }, ...items]);
            }
        } else {
            window.alert('هیچ کاڵایەک نەدۆزرایەوە');
        }
    });
}